import MuiCardMedia from '@mui/material/CardMedia';
import { styled } from '@mui/material/styles';

export const CardMedia = styled(MuiCardMedia)<{ component: string; alt: string }>(({ theme }) => ({
  marginBottom: theme.spacing(1),
  width: '200px',
  height: '200px',
}));
